import { render } from "./ExamTest.vue?vue&type=template&id=d70e3092"
import script from "./ExamTest.vue?vue&type=script&lang=ts"
export * from "./ExamTest.vue?vue&type=script&lang=ts"

import "./ExamTest.vue?vue&type=style&index=0&id=d70e3092&lang=css"
script.render = render

export default script